module.exports = __webpack_public_path__ + "img/4.525097d8.jpg";